import UseContext from "../../../hooks/useContext";
import ModalEditWorkerPhone from "./data/modalEditWorkerPhone/ModalEditWorkerPhone";
import ModalEditWorkerToken from "./data/modalEditWorkerToken/ModalEditWorkerToken";

const dataModal = new Map();
dataModal.set("edit_worker_phone", <ModalEditWorkerPhone />);
dataModal.set("edit_worker_token", <ModalEditWorkerToken />);

const Datamodal = () => {
  const { modalType } = UseContext();
  return <>{dataModal.get(modalType)}</>;
};

export default Datamodal;
